/**
 * ECOM-2761: keep-list of experiments that may emit the `experiment_triggered`
 * tracking event.
 *
 * The event previously fired for every active experiment on every route change,
 * making up the bulk of server-side (sGTM) tracking volume. Instead of tracking
 * every experiment by default, `useExperimentTracking` now only emits the event
 * for the experiments named here. This is a keep-list on purpose: any experiment
 * added to the registry in future is silent for tracking unless it is explicitly
 * added below.
 *
 * Note: only whole experiments are listed — variant selection does not matter, so
 * both variants of `experiment-plp` (`default` and `odoscope-plp`) are tracked.
 */
export const TRACKED_EXPERIMENTS = [
  'experiment-plp',
  'experiment-leap-script',
] as const

/**
 * True when `experiment_triggered` should be emitted for the given experiment
 * name. Every experiment not in the keep-list — listed obsolete or not — is
 * silent.
 */
export const isTrackedExperiment = (name: string): boolean =>
  (TRACKED_EXPERIMENTS as readonly string[]).includes(name)
